// Словарь документов (подпроект 4): хранилище «Документы», настройки текстов и нумерации, публичная оферта,
// строки PDF. Подключается в `ru.ts` одной строкой, чтобы не мешать соседним разделам.

/** Тексты ошибок `documents.*` (раздел 11 спецификации подпроекта 4). */
export const ruDocumentsErrors = {
  render_timeout: 'PDF собирается дольше обычного — попробуйте ещё раз через несколько секунд',
  offer_not_published: 'Сначала опубликуйте оферту в настройках документов',
  template_variable_unknown: 'В тексте неизвестная подстановка {name} — выберите её из списка подстановок',
  template_sections_too_many: 'В тексте не больше 60 разделов — объедините короткие',
  template_section_title_too_long: 'Заголовок раздела длиннее 300 знаков — сократите',
  template_too_large: 'Текст документа слишком большой — сократите его или разбейте на приложения',
  template_empty: 'В тексте нет ни одного раздела — опубликовать нечего',
  template_title_required: 'Назовите документ — например, «Заявка»',
  template_title_too_long: 'Название документа длиннее 120 знаков — сократите',
  signing_fixed: 'У этого документа порядок подписи задан самим документом и не меняется',
  settings_prefix_invalid: 'Префикс номера — от 1 до 6 букв или цифр, без пробелов и дефисов',
  settings_prefix_taken: 'У двух серий одинаковый префикс — номера документов совпали бы',
  settings_link_days_invalid: 'Срок ссылки на подпись — от 1 до 90 дней',
  settings_code_minutes_invalid: 'Срок кода — от 1 до 60 минут',
  settings_code_attempts_invalid: 'Попыток ввода кода — от 1 до 10',
  settings_resend_invalid: 'Повторная отправка кода — через 10–600 секунд',
  title_required: 'Назовите документ — например, «Договор аренды офиса»',
  title_too_long: 'Название документа длиннее 300 знаков — сократите',
  number_too_long: 'Номер документа длиннее 60 знаков — сократите',
  date_invalid: 'Укажите дату документа',
  amount_required: 'Укажите сумму счёта — по ней оплаты разносятся по счёту',
  deal_not_found: 'Сделка не найдена — возможно, её удалили',
  client_not_found: 'Клиент не найден — возможно, его удалили',
  employee_not_found: 'Сотрудник не найден',
  employment_form_required: 'Сначала администратор выбирает форму работы сотрудника',
  employee_contract_exists:
    'Договор с сотрудником уже на подписи или подписан — новый собирается после отзыва',
  paper_scan_not_needed: 'Скан бумажного оригинала прикладывают только к подписанному трудовому договору',
  payout_period_order: 'Начало периода позже его конца — поменяйте даты местами',
  payout_lines_required: 'Добавьте хотя бы одну строку: задача и сумма',
  payout_line_taken: 'Часы из этой строки уже стоят в другом акте о выплате — уберите строку',
  payout_line_mismatch:
    'Строка из «К выплате» не сходится с подтверждёнными часами — откройте акт заново из «К выплате»',
  payout_line_title_required: 'Строка {n}: напишите задачу',
  payout_line_title_too_long: 'Строка {n}: название задачи длиннее 300 знаков — сократите',
  payout_line_amount_invalid: 'Строка {n}: сумма — больше нуля, до копейки',
  payout_line_hours_invalid: 'Строка {n}: часы — от 0 до 744',
  binding_mismatch: 'Сделка относится к другому клиенту — выберите клиента этой сделки или очистите поле',
  generated_immutable: 'Документ собран платформой — его данные не меняются. Исправление — допсоглашением',
  archived: 'Документ в архиве — сначала верните его',
  not_archived: 'Документ не в архиве',
  restore_replaced: 'Документ заменён новым файлом — действует замена, прежний остаётся в архиве',
  archive_draft: 'Черновик не архивируют — его можно удалить',
  delete_forbidden: 'Удалить можно только черновик. Подписанный и отправленный документ — в архив',
  kind_not_uploadable: 'Оферту не загружают файлом — её публикуют в настройках документов',
  package_not_frozen: 'Пакет ещё не отправлен на подпись',
  studio_signer_required: 'Укажите в реквизитах, кто подписывает за студию в платформе',
  party_signer_required: 'Укажите у клиента, кто подписывает и его почту',
  not_studio_signer: 'Подписать за студию может только подписант из реквизитов',
  not_your_turn: 'Сейчас очередь другого подписанта — дождитесь его подписи',
  signer_inactive: 'Подписант отключён — отзовите пакет и соберите новый',
  code_resend_wait: 'Новый код можно запросить через {seconds} с',
  code_invalid: 'Код не подошёл — проверьте цифры из письма',
  code_expired: 'Код устарел — запросите новый',
  too_many_attempts: 'Слишком много попыток — запросите новый код',
  package_changed: 'Документы изменились — откройте актуальную ссылку',
  link_not_found: 'Ссылка не найдена — проверьте адрес из письма',
  link_revoked: 'Ссылка отозвана — напишите менеджеру',
  link_expired: 'Срок ссылки истёк — напишите менеджеру',
  signed_immutable: 'Подписанный документ изменить нельзя — оформите допсоглашение',
  package_closed: 'Пакет уже не ждёт подписи',
  revoke_closed: 'Отозвать можно только пакет, который ещё на подписи',
  nothing_to_sign: 'Этот документ никто не подписывает — его не отправляют на подпись',
  not_party_turn: 'Ссылка нужна, когда очередь дошла до другой стороны',
  package_not_signed: 'Лист подписания появится, когда документы подпишут все',
  not_generated: 'Документ загружен файлом — откройте файл',
  consent_required: 'Подтвердите согласие подписать документы простой электронной подписью',
  question_required: 'Напишите вопрос',
  question_too_long: 'Вопрос длиннее {max} знаков — сократите',
  decline_reason_required: 'Напишите причину отказа — менеджер разберётся',
  decline_reason_too_long: 'Причина длиннее {max} знаков — сократите',
  scan_date_future: 'Дата подписания не может быть позже сегодняшней',
  not_ready: 'Договор пока не собрать — заполните то, что подсвечено',
  contract_exists: 'У сделки уже есть договор на подписи — отзовите его, чтобы собрать новый',
  deal_closed: 'Сделка закрыта — договор по ней не собирается',
  order_not_signed: 'Счета, акты и допсоглашения — после подписания заявки клиентом',
  not_won: 'Счета и акты выставляются по выигранной сделке',
  part_not_found: 'Такой доли нет в графике оплат заявки',
  acts_exceed_order: 'Сумма актов больше суммы договора',
  act_amount_invalid: 'Укажите сумму акта больше нуля',
  act_title_required: 'Напишите, что сделано: например, «Этап «Дизайн»»',
  amendment_empty: 'Опишите, что меняется: сроки, состав или цену',
  amendment_amount_invalid: 'Новая сумма договора — больше нуля',
  amendment_specification_missing:
    'Состав или цена меняются — приложите новую спецификацию из КП или перечислите работы',
  remarks_required: 'Напишите замечания к акту — менеджер разберётся',
} as const;

export const ruDocumentsAudit = {
  actions: {
    document: {
      uploaded: 'Загружен документ',
      changed: 'Изменены данные документа',
      replaced: 'Файл документа заменён',
      archived: 'Документ в архиве',
      restored: 'Документ возвращён из архива',
      deleted: 'Удалён черновик документа',
      invoice_issued: 'Выставлен счёт',
    },
    document_template: {
      draft_started: 'Начат черновик текста',
      draft_discarded: 'Черновик текста отменён',
      published: 'Опубликована версия текста',
      changed: 'Изменены название или порядок подписи',
    },
    document_settings: {
      changed: 'Изменены настройки документов',
    },
    document_package: {
      frozen: 'Пакет отправлен на подпись',
      code_sent: 'Отправлен код подписи',
      signed_by: 'Подписано',
      sent: 'Ссылка на подпись отправлена письмом',
      link_created: 'Создана ссылка на подпись',
      viewed: 'Сторона открыла документы',
      signed: 'Пакет подписан',
      declined: 'Сторона отказалась подписать',
      question: 'Вопрос по документам',
      revoked: 'Пакет отозван',
      extended: 'Ссылка на подпись продлена',
      scan_uploaded: 'Загружен скан подписанных документов',
      paper_scan_attached: 'Приложен скан бумажного оригинала',
    },
  },
  entities: {
    document: 'Документ',
    document_template: 'Вид документа',
    document_settings: 'Настройки документов',
    document_package: 'Подписание',
  },
  fields: {
    documentKind: 'Вид документа',
    documentNumber: 'Номер документа',
    issuedOn: 'Дата документа',
    signedOn: 'Дата подписания',
    client: 'Клиент',
    deal: 'Сделка',
    employee: 'Сотрудник',
    fileName: 'Файл',
    textVersion: 'Версия текста',
    signing: 'Кто подписывает',
    prefix_order: 'Префикс заявок',
    prefix_invoice: 'Префикс счетов',
    prefix_act: 'Префикс актов',
    prefix_employee_contract: 'Префикс договоров с сотрудниками',
    prefix_payout_act: 'Префикс актов о выплате',
    linkValidDays: 'Срок ссылки на подпись, дней',
    codeMinutes: 'Срок кода, минут',
    codeAttempts: 'Попыток ввода кода',
    resendSeconds: 'Повтор кода через, секунд',
    winOnSign: 'Подпись заявки выигрывает сделку',
    documents: 'Документы',
    signer: 'Подписант',
    sentTo: 'Куда',
    method: 'Способ',
    device: 'Устройство',
    text: 'Текст',
  },
} as const;

export const ruDocuments = {
  offerFileName: 'Оферта, версия {n}.pdf',
  nav: 'Документы',
  title: 'Документы',
  lead: 'Договоры, счета, акты и сканы студии — с поиском и привязкой к клиенту, сделке или сотруднику.',
  hint: {
    title: 'Хранилище документов',
    text: 'Все документы студии: собранные в платформе и загруженные файлом. Подписанный документ не меняется — исправление оформляют допсоглашением.',
    example: 'Скан бумажного договора аренды: вид «Другое», дата и отметка «подписан».',
  },
  uploadButton: 'Загрузить документ',
  searchPlaceholder: 'Номер или название',
  filters: {
    kindAll: 'Все виды',
    statusAll: 'Все',
    period: 'Период',
    active: 'Действующие',
    archived: 'Архив',
    client: 'Клиент: {name}',
    deal: 'Сделка: {name}',
    employee: 'Сотрудник: {name}',
    clientAny: 'Документы клиента',
    dealAny: 'Документы сделки',
    employeeAny: 'Документы сотрудника',
    removeBinding: 'Убрать фильтр',
  },
  columns: {
    document: 'Документ',
    party: 'Сторона',
    amount: 'Сумма',
    status: 'Статус',
    date: 'Дата',
  },
  noParty: 'Без привязки',
  emptyTitle: 'Документов пока нет',
  emptyText:
    'Здесь будут договоры, счета и акты из сделок. Скан бумажного документа можно загрузить уже сейчас.',
  emptyReadOnlyText: 'Здесь будут договоры, счета и акты из сделок.',
  emptyFilteredTitle: 'Под фильтры ничего не подходит',
  emptyFilteredText: 'Измените вид, статус или период — или сбросьте фильтры.',
  emptyArchivedTitle: 'В архиве пусто',
  emptyArchivedText: 'Сюда уходят документы, убранные в архив, и файлы, которые заменили новыми.',
  resetFilters: 'Сбросить фильтры',
  moreHint: 'Показаны первые {count} из {total} — уточните фильтры или поиск',
  notFound: 'Документ не найден',
  notFoundText: 'Возможно, черновик удалили. Остальные документы не удаляются — загляните в архив.',
  archivedToast: '«{title}» — в архиве',
  restoredToast: 'Документ возвращён из архива',
  restoreFailed: 'Не удалось вернуть документ из архива',
  deletedToast: 'Черновик удалён',
  saveFailed: 'Не удалось сохранить документ',
  card: {
    tabDocument: 'Документ',
    tabRelated: 'Связанные',
    tabHistory: 'История',
    more: 'Действия с документом',
    edit: 'Изменить данные',
    replace: 'Заменить файл',
    archive: 'В архив',
    restore: 'Вернуть из архива',
    delete: 'Удалить черновик',
    download: 'Скачать',
    open: 'Открыть',
    kind: 'Вид',
    number: 'Номер',
    noNumber: 'Без номера',
    issuedOn: 'Дата документа',
    signature: 'Подпись',
    signedOn: 'Подписан {date}',
    notSigned: 'Не подписан',
    amount: 'Сумма',
    client: 'Клиент',
    deal: 'Сделка',
    employee: 'Сотрудник',
    origin: 'Откуда',
    textVersion: 'Версия текста',
    textVersionValue: 'Версия {n}',
    hash: 'Хэш SHA-256',
    file: 'Файл',
    noFile: 'Файла нет — документ ещё не собран',
    previewFailed: 'Предпросмотр не открылся — скачайте файл',
    previewUnavailable: 'Такой файл браузер не покажет — скачайте его',
    archivedBanner: 'Документ в архиве: в таблице он виден только в «Архиве»',
    replacedBanner: 'Файл заменён новым — действует замена, этот экземпляр остаётся в архиве',
    openReplacement: 'Открыть замену',
    parent: 'Относится к',
    children: 'Приложения, счета и акты',
    replaces: 'Заменил',
    relatedEmpty: 'Связанных документов нет',
    hints: {
      immutable: {
        title: 'Почему файл нельзя изменить',
        text: 'Файл загруженного документа не меняется: замена создаёт новый документ, а прежний уходит в архив со ссылкой на новый. Так подписанный экземпляр нельзя подменить молча.',
      },
      generated: {
        title: 'Собран в платформе',
        text: 'Документ собран из шаблона и данных сделки. Его данные и хэш не меняются; исправление — допсоглашением.',
      },
      hash: {
        title: 'Хэш',
        text: 'Отпечаток содержимого: если бы в документе изменилась хоть одна буква, хэш был бы другим.',
      },
    },
  },
  upload: {
    title: 'Загрузить документ',
    lead: 'Скан или PDF документа. После сохранения файл не меняется — замена создаёт новый документ.',
    editTitle: 'Данные документа',
    editLead: 'Опечатка в номере, дате или привязке — поправьте здесь. Файл остаётся тем же.',
    file: 'Файл',
    fileHint: 'PDF, JPG или PNG до 50 МБ',
    fileRequired: 'Добавьте файл документа',
    kind: 'Вид документа',
    kindRequired: 'Выберите вид документа',
    kindPlaceholder: 'Выберите вид',
    name: 'Название',
    namePlaceholder: 'Например, «Договор аренды офиса»',
    number: 'Номер',
    numberPlaceholder: 'Если есть',
    date: 'Дата документа',
    amount: 'Сумма, ₽',
    signed: 'Документ подписан',
    signedHint: 'Датой подписания станет дата документа',
    binding: 'К чему относится',
    bindingHint: {
      title: 'Привязка',
      text: 'Документ сделки виден и в документах её клиента. Можно не привязывать — документ останется в общем списке.',
    },
    client: 'Клиент',
    clientPlaceholder: 'Найдите клиента',
    clientFromDeal: 'Клиент возьмётся из сделки',
    deal: 'Сделка',
    dealPlaceholder: 'Найдите сделку',
    employee: 'Сотрудник',
    employeePlaceholder: 'Выберите сотрудника',
    inn: 'ИНН {inn}',
    clientKind: 'Клиент',
    dealKind: 'Сделка',
    submit: 'Загрузить',
    save: 'Сохранить',
    uploaded: 'Документ загружен',
    saved: 'Данные документа сохранены',
  },
  replace: {
    title: 'Заменить файл',
    lead: 'Новый файл станет отдельным документом с теми же данными, а прежний уйдёт в архив со ссылкой на замену.',
    file: 'Новый файл',
    submit: 'Заменить',
    replaced: 'Файл заменён — прежний в архиве',
  },
  settings: {
    title: 'Документы',
    pageTitle: 'Настройки документов',
    hint: {
      title: 'Настройки документов',
      text: 'Тексты оферты, заявки, договоров и актов, порядок подписи, нумерация и сроки подписания. Шапку, реквизиты сторон, таблицы и подписи задаёт шаблон — здесь правится только текст.',
    },
    tabs: { texts: 'Тексты', numbering: 'Нумерация и сроки', history: 'История' },
    groups: { offer: 'Оферта', site: 'Документы сайта', client: 'С клиентом', employee: 'С сотрудником' },
    statusPublished: 'Версия {n} от {date}',
    statusDraft: 'черновик',
    statusNone: 'Не опубликован',
    notPublishedNote:
      'Текст не опубликован — такие документы пока не собираются. Проверьте стартовый текст и опубликуйте его.',
    name: 'Название документа',
    signing: 'Кто подписывает',
    signingFixed: 'Порядок подписи задан самим документом',
    signingHint: {
      title: 'Порядок подписи',
      text: 'Подписанты идут строго по очереди: следующий получает ссылку и код, только когда подписал предыдущий. Подпись последнего завершает пакет. Новый порядок действует для новых пакетов.',
    },
    sections: 'Текст документа',
    sectionsHint: {
      title: 'Разделы и подстановки',
      text: 'Текст делится на разделы с заголовками. Кнопка с фигурными скобками в панели редактора вставляет подстановку — при сборке на её месте появятся данные студии, клиента или сотрудника. Неизвестную подстановку сохранить не получится.',
      example: 'Подстановка «Клиент — название» станет «ООО „Ромашка“».',
    },
    sectionTitle: 'Заголовок раздела',
    sectionTitlePlaceholder: 'Например, «Предмет договора»; можно без заголовка',
    sectionBody: 'Текст раздела',
    sectionPlaceholder: 'Текст раздела',
    sectionNumber: 'Раздел {n}',
    addSection: 'Добавить раздел',
    moveUp: 'Поднять раздел',
    moveDown: 'Опустить раздел',
    removeSection: 'Убрать раздел',
    sectionRemoved: 'Раздел убран',
    insert: 'Подстановка',
    saveDraft: 'Сохранить черновик',
    publish: 'Опубликовать',
    discardDraft: 'Отменить черновик',
    resetEdits: 'Вернуть как было',
    draftSaved: 'Черновик сохранён',
    published: 'Опубликована версия {n}',
    draftDiscarded: 'Черновик отменён — в редакторе действующий текст',
    starterNote: 'Стартовый текст платформы — проверьте его с юристом перед публикацией.',
    draftNote:
      'Черновик версии {n}: документы собираются по действующей версии, пока черновик не опубликован.',
    unsaved: 'Есть несохранённые правки',
    publishHint: {
      title: 'Публикация',
      text: 'Опубликованная версия больше не меняется: собранные по ней документы хранят её навсегда. Новые документы собираются по последней опубликованной версии.',
    },
    preview: 'Предпросмотр на примере',
    previewLead:
      'Реквизиты студии — настоящие, клиент, сотрудник и суммы — вымышленные. На PDF стоит отметка «Образец».',
    previewBuild: 'Собрать PDF',
    previewRefresh: 'Обновить',
    previewStale: 'Текст изменился — обновите предпросмотр',
    previewEmpty: 'Соберите PDF, чтобы увидеть документ с текстом из редактора',
    previewDownload: 'Скачать PDF',
    versions: 'Версии',
    versionsEmpty: 'Опубликованных версий пока нет',
    versionLine: 'Версия {n}',
    versionMeta: '{date} · {name}',
    versionDraft: 'черновик',
    versionCurrent: 'действует',
    versionPreview: 'PDF версии',
    publicLink: 'Публичная страница оферты',
    publicLinkHint: {
      title: 'Оферта для клиентов',
      text: 'Ссылка всегда ведёт на действующую версию: её дают клиенту и ставят в заявку. Каждая опубликованная версия навсегда остаётся по своему адресу.',
    },
    publicLinkNone: 'Страница появится после публикации оферты',
    copyLink: 'Скопировать ссылку',
    linkCopied: 'Ссылка скопирована',
    openLink: 'Открыть',
    numbering: 'Нумерация',
    numberingLead:
      'Номер присваивается, когда документ отправляют на подпись: сквозной по серии и году студии.',
    series: {
      order: 'Заявки',
      invoice: 'Счета',
      act: 'Акты',
      employee_contract: 'Договоры с сотрудниками',
      payout_act: 'Акты о выплате',
    },
    nextNumber: 'Следующий номер — {number}',
    prefixHint: {
      title: 'Префикс номера',
      text: 'До 6 букв или цифр, без пробелов и дефисов. Номер складывается из префикса, года и порядкового номера.',
      example: 'З-2026-0001',
    },
    signingTerms: 'Подписание',
    signingTermsLead: 'Срок ссылки на подпись и правила кода из письма — для всех пакетов.',
    linkValidDays: 'Ссылка на подпись действует',
    linkValidDaysHint: {
      title: 'Срок ссылки',
      text: 'Сколько дней после отправки сторона может открыть и подписать документы. Истёкшую ссылку менеджер продлевает.',
    },
    codeMinutes: 'Код из письма действует',
    codeAttempts: 'Попыток ввода кода',
    resendSeconds: 'Новый код — не чаще чем через',
    winOnSign: 'Подписанная клиентом заявка выигрывает сделку',
    winOnSignHint: 'Сделка сама станет «Выиграна», бюджет — сумма заявки',
    unitDays: 'дн.',
    unitMinutes: 'мин',
    unitSeconds: 'с',
    history: 'История настроек',
    templatesHistory: 'История текста',
  },
  variableGroups: {
    studio: 'Студия',
    client: 'Клиент',
    signer: 'Подписант клиента',
    employee: 'Сотрудник',
    document: 'Документ',
    order: 'Заявка',
    contract: 'Договор с сотрудником',
    offer: 'Оферта',
    project: 'Проект',
  },
  /** Подписи подстановок в редакторе: ключ — имя подстановки, точка заменена подчёркиванием. */
  variables: {
    studio_name: 'Название',
    studio_full_name: 'Полное название',
    studio_party: 'Сторона договора — «в лице…»',
    studio_inn: 'ИНН',
    studio_kpp: 'КПП',
    studio_ogrn: 'ОГРН или ОГРНИП',
    studio_address: 'Юридический адрес',
    studio_bank_name: 'Банк',
    studio_bik: 'БИК',
    studio_account: 'Расчётный счёт',
    studio_corr_account: 'Корреспондентский счёт',
    studio_signer_name: 'Подписант — ФИО',
    studio_signer_position: 'Подписант — должность',
    studio_signer_basis: 'Подписант — основание',
    studio_email: 'Почта',
    studio_phone: 'Телефон',
    studio_site: 'Сайт',
    client_name: 'Название',
    client_full_name: 'Полное название',
    client_party: 'Сторона договора — «в лице…»',
    client_inn: 'ИНН',
    client_kpp: 'КПП',
    client_ogrn: 'ОГРН или ОГРНИП',
    client_address: 'Адрес',
    client_director: 'Руководитель — ФИО',
    client_director_position: 'Руководитель — должность',
    client_director_basis: 'Руководитель — основание',
    client_email: 'Почта',
    client_phone: 'Телефон',
    client_bank_name: 'Банк',
    client_bik: 'БИК',
    client_account: 'Расчётный счёт',
    client_corr_account: 'Корреспондентский счёт',
    signer_name: 'ФИО',
    signer_position: 'Должность',
    signer_basis: 'Основание полномочий',
    signer_email: 'Почта для кода',
    employee_name: 'ФИО',
    employee_position: 'Должность',
    employee_birth_date: 'Дата рождения',
    employee_passport: 'Паспорт',
    employee_address: 'Адрес регистрации',
    employee_inn: 'ИНН',
    employee_snils: 'СНИЛС',
    employee_ogrnip: 'ОГРНИП',
    employee_npd_date: 'Самозанятый с',
    employee_bank_name: 'Банк',
    employee_bik: 'БИК',
    employee_account: 'Счёт',
    employee_email: 'Почта',
    employee_phone: 'Телефон',
    document_number: 'Номер',
    document_date: 'Дата',
    order_number: 'Номер заявки',
    order_date: 'Дата заявки',
    contract_number: 'Номер договора',
    contract_date: 'Дата договора',
    offer_version: 'Номер версии',
    offer_date: 'Дата версии',
    offer_url: 'Ссылка на версию',
    amount: 'Сумма',
    amount_words: 'Сумма прописью',
    vat_note: 'НДС',
    term: 'Срок работ',
    project_title: 'Название проекта',
    stage: 'Этап или доля оплаты',
    period: 'Период',
  },
  /** Виды документов: подписи в таблице, фильтрах и настройках. */
  kinds: {
    offer: 'Оферта',
    order: 'Заявка',
    specification: 'Спецификация',
    invoice: 'Счёт',
    act: 'Акт',
    amendment: 'Допсоглашение',
    employee_npd: 'Договор с самозанятым',
    employee_ip: 'Договор с ИП',
    employee_gph: 'Договор ГПХ',
    employee_staff: 'Трудовой договор',
    payout_act: 'Акт о выплате',
    subscription_offer: 'Оферта на подписку',
    privacy_policy: 'Политика конфиденциальности',
    pd_consent: 'Согласие на обработку ПДн',
    other: 'Другое',
  },
  /** Кто подписывает документ вида. */
  signing: {
    none: 'Никто',
    studio: 'Только студия',
    party: 'Только другая сторона',
    studio_then_party: 'Студия, затем другая сторона',
    party_then_studio: 'Другая сторона, затем студия',
  },
  statuses: {
    draft: 'Черновик',
    frozen: 'Не подписан',
    signed: 'Подписан',
    void: 'Отозван',
    /** Счёт: не подписывается, «заморожен» у него — выставлен. */
    issued: 'Выставлен',
  },
  origins: {
    generated: 'Собран в платформе',
    uploaded: 'Загружен файлом',
  },
  /** Строки PDF: шапка, стороны, реквизиты, подписи. */
  render: {
    studioFallback: 'Студия',
    partyWithSigner: '{name}, от имени которого действует {signer}',
    partyWithSignerBasis: '{name}, от имени которого действует {signer} на основании {basis}',
    inn: 'ИНН {inn}',
    innKpp: 'ИНН {inn}, КПП {kpp}',
    ogrn: '{label} {ogrn}',
    ogrnLabel: 'ОГРН',
    ogrnipLabel: 'ОГРНИП',
    address: 'Адрес: {address}',
    account: 'р/с {account}',
    accountIn: 'р/с {account} в {bank}',
    bik: 'БИК {bik}',
    bikCorr: 'БИК {bik}, к/с {corr}',
    passport: 'Паспорт {passport}',
    vatIncluded: 'в том числе НДС {rate}',
    vatNone: 'НДС не облагается',
    methodCode: 'Код из письма',
    methodScan: 'Скан бумажного документа',
    signingNote:
      'Документы подписаны простой электронной подписью: ключ — одноразовый код, отправленный на адрес почты подписанта. Хэш SHA-256 подтверждает, что после подписания документы не менялись.',
    roleContractor: 'Исполнитель',
    roleCustomer: 'Заказчик',
    roleEmployer: 'Работодатель',
    roleEmployee: 'Работник',
    numbered: '{title} № {number}',
    numberedDated: '{title} № {number} от {date}',
    offerVersion: 'Версия {n} от {date}',
    toOffer: 'к публичной оферте, версия {n} от {date}',
    appendix: 'Приложение № 1 к заявке № {number} от {date}',
    toOrder: 'к заявке № {number} от {date}',
    toContract: 'к договору № {number} от {date}',
    stampSample: 'Образец',
    factProject: 'Проект',
    factPackage: 'Пакет',
    factTerm: 'Срок',
    /** Срок заявки и спецификации — в рабочих днях (решение владельца 2026-10-10). */
    workDays: {
      one: '{count} рабочий день',
      few: '{count} рабочих дня',
      many: '{count} рабочих дней',
      other: '{count} рабочего дня',
    },
    workDay: 'Рабочий день {day}',
    workDayRange: 'Рабочие дни {from}–{to}',
    factAmount: 'Стоимость',
    invoicePurpose: 'Оплата по счёту № {number} к заявке № {order}, {vat}',
    unitService: 'усл.',
    signedAtZone: '{at} ({zone})',
    signingNoteScan:
      'Документы подписаны сторонами на бумаге; в платформу загружен скан подписанных экземпляров. Хэш SHA-256 подтверждает, что после подписания документы в платформе не менялись.',
    sheetTitle: 'Лист подписания — {title}',
    stampVoid: 'Отозван',
    stampDraft: 'Черновик',
    factSupport: 'Поддержка',
    supportValue: '{name}: {hours} ч в месяц, {price} за {period}',
    factSupportTerms: 'Условия поддержки',
    supportTermsValue: 'оферта на подписку, версия {version} от {date}, {url}',
    periodMonth: 'месяц',
    periodYear: 'год',
    invoiceItem: '{label} по заявке № {order}',
    factNewAmount: 'Новая стоимость',
    amendmentNumber: '{n} к заявке № {order}',
    amendmentAppendix: 'Приложение № 1 к дополнительному соглашению № {number}',
    finalAct: 'Работы по проекту «{project}»',
  },
  /** Согласие на простую электронную подпись перед кодом (раздел 5, «Подпись кодом»). */
  consent: {
    studio:
      'Я, {name}, подписываю документы пакета от имени {studio} простой электронной подписью. Ключ подписи — одноразовый код из письма на мою почту.',
    offer:
      'Я, {name}, ознакомлен(а) с документами пакета и подписываю их простой электронной подписью на условиях публичной оферты, версия {n} ({url}). Ключ подписи — одноразовый код из письма на мою почту.',
    offerVersion: 'Оферта, версия {n}',
    contract:
      'Я, {name}, ознакомлен(а) с документами пакета и подписываю их простой электронной подписью на условиях договора «{title}». Ключ подписи — одноразовый код из письма на мою почту.',
    plain:
      'Я, {name}, ознакомлен(а) с документами пакета и подписываю их простой электронной подписью. Ключ подписи — одноразовый код из письма на мою почту.',
  },
  notifications: {
    awaitingTitle: 'Ждёт вашей подписи: {title}',
    awaitingStudioBody: 'За студию — с {party}. Подпись кодом из письма',
    awaitingPartyBody: 'Посмотрите документы и подпишите кодом из письма',
    studioSignedTitle: 'Подписано студией — ушло: {party}',
    firstViewedTitle: '{party} открыл(а) документы',
    signedTitle: '{party} подписал(а) документы',
    declinedTitle: 'Отказ от подписи: {reason}',
    remarksTitle: 'Замечания к акту: {reason}',
    questionTitle: 'Вопрос по документам: {title}',
    expiringTitle: 'Ссылка на подпись истекает завтра',
    expiringBody: '{title} — {party}. Продлите ссылку или напомните о подписи',
    signContractTitle: 'Подпишите договор: {title}',
    signPayoutTitle: 'Подпишите акт о выплате: {title}',
    employeeSignedContractTitle: 'Сотрудник подписал договор: {party}',
    employeeSignedPayoutTitle: 'Сотрудник подписал акт: {party}',
    paperMissingTitle: 'Нет бумажного оригинала штатного договора',
    paperMissingBody: '{party}: {title} подписан кодом — приложите скан бумажного оригинала',
    contractReminderTitle: 'Подпишите договор',
    contractReminderData:
      'Заполните свои данные — договор соберётся сам, останется подписать кодом из письма',
    contractReminderSign: 'Договор готов — подпишите его кодом из письма',
  },
  /** Пакет на подпись: вкладка «Подписание» в карточке документа и окно подписи. */
  packages: {
    tab: 'Подписание',
    hint: {
      title: 'Подпись кодом из письма',
      text: 'Простая электронная подпись: подписант смотрит документы, соглашается подписать их и вводит одноразовый код из письма. Подписанное не меняется — лист подписания хранит, кто, когда, с какой почты и что именно подписал (хэш).',
      example: 'Заявка: сначала подписывает студия, потом клиент — ссылка уходит ему сама.',
    },
    states: {
      draft: 'Черновик',
      signing: 'На подписи',
      signed: 'Подписан',
      declined: 'Отказ',
      revoked: 'Отозван',
      expired: 'Срок ссылки истёк',
    },
    queue: 'Кто подписывает',
    queueHint: {
      title: 'Порядок подписи',
      text: 'Подписанты идут строго по очереди: следующий получает код и ссылку, только когда предыдущий подписал. Порядок задан у вида документа в «Настройки → Документы».',
    },
    signerWaits: 'Ждёт очереди',
    signerCurrent: 'Сейчас очередь',
    signerSigned: 'Подписал(а) {at}',
    signerDeclined: 'Отказ: {reason}',
    signerMethodCode: 'код из письма · {email}',
    signerMethodScan: 'скан бумажного документа',
    signerIp: 'IP {ip}',
    validUntil: 'Ссылка действует до {date}',
    viewsNone: 'Сторона ещё не открывала документы',
    views: 'Открыто: {count} · впервые {at}',
    expiredBanner: 'Срок ссылки истёк — продлите её, и сторона снова сможет подписать',
    revokedBanner:
      'Пакет отозван: ссылка не открывается, документы остались с номерами и пометкой «Отозван». Соберите новый пакет',
    declinedBanner: 'Сторона отказалась подписать: {reason}',
    signedCode: 'Подписан {date} — кодом из письма',
    signedScan: 'Подписан {date} — скан бумажных экземпляров',
    hash: 'Хэш пакета',
    documents: 'Документы пакета',
    sheet: 'Лист подписания',
    downloadSheet: 'Скачать лист подписания',
    scanFile: 'Скан подписанных экземпляров',
    paperScanFile: 'Скан бумажного оригинала',
    history: 'История подписания',
    sign: 'Подписать',
    signTitle: 'Подписать документы',
    signLead: 'Проверьте документы пакета. Код придёт на почту входа.',
    getCode: 'Получить код',
    resend: 'Отправить код ещё раз',
    resendIn: 'Новый код — через {seconds} с',
    codeSent: 'Код отправлен на {email}. Проверьте и «Спам»',
    codeLabel: 'Код из письма',
    codeHint: '6 цифр',
    attemptsLeft: 'Осталось попыток: {count}',
    agree: 'Согласен(на) подписать',
    signedToast: 'Подписано',
    signFailed: 'Не удалось подписать',
    copyLink: 'Скопировать ссылку',
    linkCopied: 'Ссылка на подпись скопирована — она действует до {date}',
    resendLink: 'Отправить ссылку ещё раз',
    linkSent: 'Ссылка отправлена на {email}',
    revoke: 'Отозвать',
    revoking: 'Отзываем «{title}»',
    revoked: 'Пакет отозван',
    extend: 'Продлить ссылку',
    extended: 'Ссылка продлена до {date}',
    scan: 'Загрузить скан',
    scanTitle: 'Скан подписанных документов',
    scanLead:
      'Стороны подписали на бумаге? Загрузите скан всех подписанных страниц одним файлом и дату подписания — пакет станет подписанным, способ — скан.',
    scanFileLabel: 'Скан',
    scanFileHint: 'PDF, JPG или PNG до 50 МБ',
    scanDate: 'Дата подписания',
    scanSave: 'Сохранить',
    scanDone: 'Пакет подписан сканом',
    actionFailed: 'Не удалось — попробуйте ещё раз',
    sides: { studio: 'Студия', party: 'Другая сторона' },
  },
  /** «Сегодня»: пакеты, которые ждут подписи смотрящего. */
  today: {
    awaitingTitle: 'Ждут вашей подписи',
    awaitingHint:
      'Пакеты документов, где очередь дошла до вас. Подпись — кодом из письма; после неё документы уходят следующему сам.',
    awaitingExample: 'Заявка для ООО «Пример»: подпишите за студию — клиенту уйдёт ссылка.',
    awaitingStudio: 'За студию · {party}',
    awaitingParty: 'Ваша подпись',
    awaitingSince: 'с {date}',
    clientTitle: 'Ждут клиента',
    clientHint:
      'Договоры и акты ваших сделок, которые студия подписала и отправила клиенту. Если клиент тянет — напомните или продлите ссылку на странице договора.',
    clientExample: 'Заявка для ООО «Пример» ждёт 3 дня, клиент открывал 2 раза — позвоните.',
    clientDays: {
      one: 'ждёт {count} день',
      few: 'ждёт {count} дня',
      many: 'ждёт {count} дней',
      other: 'ждёт {count} дня',
    },
    clientToday: 'отправлено сегодня',
    clientViews: 'открыто: {count}',
    clientNotViewed: 'не открывал',
    clientExpired: 'ссылка истекла',
  },
  /** Договор в сделке (подпроект 4.3): шаг пути «Договор», страница договора, счета, акты, допсоглашения. */
  contract: {
    packageTitle: 'Заявка № {number}',
    palette: 'Открыть договор',
    specificationTitle: '{title} к заявке № {number}',
    amendmentSpecificationTitle: '{title} к допсоглашению № {number}',
    title: 'Договор',
    hint: {
      title: 'Оферта и заявка',
      text: 'С клиентом действует публичная оферта студии; по сделке клиент подписывает заявку к ней со спецификацией — составом, сроками и ценой из принятой версии КП. Счёт на предоплату едет в том же пакете. Сначала подписывает студия, потом клиент — кодом из письма.',
      example:
        'Клиент выбрал «Оптимальный» за 450 000 ₽: заявка, спецификация и счёт на 50 % уйдут одним пакетом.',
    },
    stages: {
      build: 'Соберите договор',
      studio: 'На подписи у студии',
      client: 'Ждёт клиента',
      clientViews: {
        one: 'Ждёт клиента · открыто {count} раз',
        few: 'Ждёт клиента · открыто {count} раза',
        many: 'Ждёт клиента · открыто {count} раз',
        other: 'Ждёт клиента · открыто {count} раза',
      },
      signed: 'Подписан',
    },
    blockOpen: 'Открыть договор',
    blockWaitProposal: 'Договор собирается, когда клиент выбрал пакет в КП',
    blockSigned: 'Подписан {date}',
    blockFrozen: 'Отправлен {date}',
    send: 'На подпись студии',
    signAndSend: 'Подписать и отправить',
    sendHint: {
      title: 'Порядок подписи',
      text: 'Сначала пакет подписывает подписант студии из реквизитов — кодом из письма. После его подписи клиенту сам уходит ссылка на страницу подписания с телефона.',
    },
    sent: 'Пакет ушёл на подпись студии',
    sentSigner: 'Пакет собран — подпишите его кодом из письма',
    documents: 'Документы пакета',
    planned: 'Войдёт в пакет',
    preview: 'Предпросмотр',
    previewHint: {
      title: 'Черновик',
      text: 'Документ собран на лету из принятой версии КП и реквизитов. Номер — тот, что документ получит при отправке, если никто не отправит раньше.',
    },
    previewFailed: 'Не удалось собрать предпросмотр — проверьте то, что подсвечено слева',
    noProposal: {
      title: 'Клиент ещё не выбрал пакет',
      text: 'Договор собирается из принятой версии КП: клиент выбирает пакет на странице КП или менеджер отмечает выбор со слов клиента.',
      action: 'Открыть КП',
    },
    lead: 'Договор появится, когда лид станет сделкой',
    closed: 'Сделка закрыта — новый договор по ней не собирается',
    accepted: 'Из {label}: {package} · {total}',
    acceptedSupport: 'Из {label}: поддержка · {total}',
    issuesTitle: 'Что дозаполнить',
    issuesLead: 'Договор не уйдёт, пока здесь есть пункты — всё заполняется на этом экране',
    ready: 'Всё готово — пакет можно отправлять',
    issues: {
      proposal_not_accepted: 'Клиент не выбрал пакет в текущей версии КП',
      template_not_published: 'Не опубликован текст «{kind}»',
      templateAction: 'Настройки документов',
      templateAsk: 'Опубликовать текст может администратор',
      studio_requisites: 'В реквизитах студии не хватает: {fields}',
      studioAction: 'Реквизиты студии',
      studio_signer: 'Не указан подписант за студию в платформе',
      client_requisites: 'У клиента не хватает реквизитов',
      party_signer: 'Не выбран подписант со стороны клиента',
      party_signer_email: 'У подписанта клиента нет почты — на неё придёт код',
      party_signer_phone: 'У клиента-физлица нет телефона',
      toClient: 'Карточка клиента',
    },
    signer: 'Подписывает за клиента',
    signerHint: {
      title: 'Подписант клиента',
      text: 'Контакт клиента с отметкой «Подписывает»: на его почту придёт ссылка на документы и код подписи. Выбор здесь ставит отметку в карточке клиента.',
    },
    signerPick: 'Выберите контакт',
    signerNone: 'У клиента нет контактов — добавьте в карточке клиента',
    signerEmail: 'Почта подписанта',
    signerPhone: 'Телефон',
    signerSaved: 'Подписант сохранён',
    previous: 'Прежние пакеты',
    previousState: '{title} · {state}',
    billing: {
      title: 'Счета и акты',
      hint: {
        title: 'По графику оплат',
        text: 'Строки — доли графика подписанной заявки. Счёт не подписывается: он уходит клиенту письмом с PDF. Акт подписывают студия и клиент — кодом или сканом.',
      },
      total: 'Договор: {total}',
      totalChanged: 'Договор: {total} (заявка {order}, с допсоглашениями)',
      remaining: 'Можно закрыть актами ещё {amount}',
      part: 'Доля',
      when: 'Когда',
      amount: 'Сумма',
      invoice: 'Выставить счёт',
      act: 'Акт',
      actFree: 'Акт на другую сумму',
      issued: 'Счетов: {count}',
      acted: 'Актов: {count}',
      invoices: 'Счета',
      acts: 'Акты',
      empty: 'Графика оплат в заявке нет — акт можно составить на любую сумму',
      notWon: 'Счета и акты — у выигранной сделки',
      duplicateInvoice: 'По этой доле уже выставлен счёт. Выставить ещё один?',
      duplicateAct: 'По этой доле уже есть акт. Составить ещё один?',
      invoiceTitle: 'Счёт по доле «{label}»',
      invoiceText: 'Счёт на {amount} получит номер и сразу станет выставленным — он не подписывается.',
      invoiceIssue: 'Выставить',
      invoiceIssued: 'Счёт {number} выставлен',
      invoiceMail: 'Отправить письмом',
      invoiceDownload: 'Скачать PDF',
      invoiceMailSubject: 'Счёт {number} — {project}',
      invoiceMailGreeting: 'Здравствуйте, {name}!',
      invoiceMailGreetingPlain: 'Здравствуйте!',
      invoiceMailText:
        'Направляем счёт {number} на {amount} по заявке {order}. PDF во вложении, в нём есть QR-код для оплаты из банковского приложения.',
      actTitle: 'Акт',
      actWhat: 'Что сделано',
      actWhatPlaceholder: 'Этап «Дизайн»',
      actAmount: 'Сумма, ₽',
      actLimit: 'Не больше {amount} — столько осталось по договору',
      actSend: 'На подпись студии',
      actSent: 'Акт ушёл на подпись студии',
    },
    amendment: {
      button: 'Допсоглашение',
      title: 'Допсоглашение к заявке {number}',
      hint: {
        title: 'Допсоглашение',
        text: 'Подписанный договор не меняется. Изменения сроков, состава или цены оформляются допсоглашением — оно подписывается так же: студия, потом клиент.',
      },
      term: 'Сроки',
      scope: 'Состав работ',
      price: 'Стоимость',
      termPlaceholder: 'Срок проекта продлевается до 10 недель',
      scopePlaceholder: 'В состав работ добавляется интеграция с CRM',
      pricePlaceholder: 'Стоимость работ увеличивается на 60 000 ₽',
      amount: 'Новая сумма договора, ₽',
      specification: 'Новая спецификация',
      specificationHint: {
        title: 'Новая спецификация',
        text: 'Если меняется состав или цена, к допсоглашению прикладывается новая спецификация: из новой версии КП (клиент её выбрал) или перечнем работ.',
      },
      fromProposal: 'Из {label} · {total}',
      manual: 'Перечнем работ',
      stage: 'Работа',
      stageTerm: 'Срок',
      addStage: 'Добавить работу',
      noProposal: 'Новой принятой версии КП нет — перечислите работы',
      send: 'На подпись студии',
      sent: 'Допсоглашение ушло на подпись студии',
      list: 'Допсоглашения',
    },
    stateLabels: {
      frozen: 'Выставлен',
      signed: 'Подписан',
      void: 'Отозван',
    },
  },
  /** Документы объекта: вкладка «Документы» у клиента. */
  objectEmpty: {
    title: 'Документов пока нет',
    text: 'Здесь появятся договоры, счета и акты по сделкам клиента и загруженные сканы',
  },
  /** Документы с сотрудником (подпроект 4.4): договор по форме работы, акт о выплате. */
  employee: {
    passportText: '{number}, выдан {issuedBy} {issuedOn}, код подразделения {code}',
    snilsLine: 'СНИЛС {snils}',
    period: 'с {from} по {to}',
    contractWord: 'Договор',
    stepTitle: 'Данные и договор',
    stepLead:
      'Заполните свои данные — договор соберётся по шаблону вашей формы работы. Подпись — кодом из письма: сначала вы, потом студия',
    postpone: 'Отложить',
    postponed: 'Напомним завтра. Работать можно и без договора',
    contractTitle: 'Договор',
    contractHint: {
      title: 'Договор с сотрудником',
      text: 'Собирается по тексту вашей формы работы из «Настройки → Документы». Сначала подписывает сотрудник, потом подписант студии — кодом из письма. Подписанное не меняется',
      example: 'Самозанятый дизайнер: договор оказания услуг, в шапке — дата постановки на учёт',
    },
    stages: {
      form: 'Форма работы не выбрана',
      data: 'Заполните данные',
      sign: 'Готов к подписи',
      employee: 'Ждёт подписи сотрудника',
      studio: 'Ждёт подписи студии',
      signed: 'Подписан',
    },
    stageMine: 'Ждёт вашей подписи',
    preview: 'Предпросмотр',
    previewFailed: 'Предпросмотр не собрался — попробуйте ещё раз',
    sign: 'Подписать договор',
    signNow: 'Подписать',
    open: 'Открыть',
    signedOn: 'Подписан {date}',
    sentOn: 'На подписи с {date}',
    paperTitle: 'Бумажный оригинал',
    paperHint: {
      title: 'Бумажный оригинал трудового договора',
      text: 'По Трудовому кодексу для трудового договора кода из письма недостаточно — юридически действует бумага. Подпишите экземпляры на бумаге и приложите скан',
    },
    paperMissing: 'Нет бумажного оригинала — приложите скан подписанного на бумаге договора',
    paperAttached: 'Скан бумажного оригинала приложен',
    paperUpload: 'Приложить скан',
    paperDialogTitle: 'Скан бумажного оригинала',
    paperDialogLead: 'Скан всех страниц трудового договора, подписанного на бумаге. Прикладывается один раз',
    paperFile: 'Файл скана',
    paperSave: 'Приложить',
    paperDone: 'Скан бумажного оригинала приложен',
    payoutsTitle: 'Акты о выплатах',
    payoutsEmpty: 'Актов о выплатах пока нет',
    payoutNew: 'Акт о выплате',
    payoutHint: {
      title: 'Акт о выплате',
      text: 'Строки «задача — часы — сумма» вручную, итог — сумма строк до копейки. Приложите чек об оплате и дополнительные данные. Сначала подписывает студия, потом сотрудник — кодом из письма',
      example: 'Сентябрь: «Макеты главной» — 12 ч — 36 000 ₽',
    },
    payoutTitle: 'Акт о выплате',
    payoutLead: 'По договору {contract}. Итог считается сам',
    periodLabel: 'Период',
    periodRequired: 'Укажите период',
    lineTitle: 'Задача',
    lineHours: 'Часы',
    noHoursNote: 'Сотрудник не в штате: в акте только задачи и суммы, без часов',
    lineAmount: 'Сумма',
    addLine: 'Добавить строку',
    removeLine: 'Убрать строку',
    total: 'Итого',
    receipt: 'Чек об оплате',
    extra: 'Дополнительные данные',
    payoutPreview: 'Предпросмотр',
    payoutSend: 'На подпись',
    payoutSent: 'Акт ушёл на подпись студии',
    contractSent: 'Договор собран — подпишите его кодом из письма',
    issues: {
      employment_form: 'Администратор ещё не выбрал форму работы',
      employment_data: 'Не хватает данных: {fields}',
      template_not_published: 'Опубликуйте текст «{kind}» в «Настройки → Документы»',
      studio_requisites: 'В реквизитах студии не хватает: {fields}',
      studio_signer: 'Укажите в реквизитах, кто подписывает за студию в платформе',
      contract_not_signed: 'Акт составляется по подписанному договору с сотрудником',
    },
    banner: {
      data: 'Подпишите договор со студией: заполните свои данные — это пара минут',
      sign: 'Договор готов — подпишите его кодом из письма',
      action: 'Данные и договор',
    },
    today: {
      title: 'Подпишите договор',
      data: 'Заполните свои данные — договор соберётся сам',
      sign: 'Договор готов — подпишите кодом из письма',
      action: 'Перейти',
    },
  },
  /** Образец для предпросмотра шаблона: вымышленный заказ. */
  example: {
    term: '30 рабочих дней',
    package: 'Оптимальный',
    stagePrepayment: 'предоплата 50 % при подписании заявки',
    stageDesign: 'этап «Дизайн»',
    period: 'сентябрь 2026 г.',
    signedAt: '{date}, 14:05 (МСК)',
    prepayment: 'Предоплата',
    whenSigning: 'при подписании заявки',
    launchPayment: 'Оплата при запуске',
    whenLaunch: 'после запуска сайта',
    invoiceItem: 'Предоплата по заявке № {order}',
  },
} as const;
